import { Pipe, PipeTransform } from '@angular/core';

export type AnimationPattern = 'home';

@Pipe({
  name: 'aosAnimate'
})
export class AosAnimatePipe implements PipeTransform {
  transform(index: number, animationPattern?: AnimationPattern): string {
    if (animationPattern === 'home') {
      return index === 0
        ? 'fade-right'
        : index == 1
          ? 'fade-down'
          : index == 2
            ? 'fade-up'
            : 'fade-left';
    }

    return index % 2 === 1
      ? 'fade-up'
      : index % 3 === 0
        ? 'fade-right'
        : 'fade-left';
  }
}
